import React from 'react';

import { ColorSchema } from '../../../typings/design-tokens';
import { getMatchResult } from '../../../utils/match-status';
import { applyColorSchema, makeClassNames } from '../../../utils/styles';
import ResultLabel from '../../atoms/result-label/result-label';
import { ILmpBlock } from '../../organisms/lmp-block/lmp-block';
import MatchCountdown from '../match-countdown/match-countdown';
import Team from '../team/team';
import './match-light.scss';

export interface IMatchLight extends ILmpBlock {}

const classNames = (colorSchema: ColorSchema) =>
  makeClassNames({
    MatchLight: ['match-light', `${applyColorSchema('match-light', colorSchema)}`],
  });

const MatchLight = ({
  match,
  /* istanbul ignore next: default value */ colorSchema = 'dark',
  /* istanbul ignore next: default value */ logoSize = '40',
  /* istanbul ignore next: default value */ fontSize = '16',
  /* istanbul ignore next: default value */ size = 'large',
  ampProps,
  countdownEnabled,
}: IMatchLight) => {
  const cn = classNames(colorSchema);
  const result = getMatchResult(match, true);
  const { status, date } = match;

  return (
    <div className={cn.MatchLight}>
      <Team
        colorSchema={colorSchema}
        name={match.home.name}
        logoSize={logoSize}
        logoUrl={match.home.logoUrl}
        fontSize={fontSize}
        iconPosition="right"
        scoreboard={match.home.scoreboard}
        isLose={match.home.isLose}
        ampProps={ampProps}
      />
      <ResultLabel itemState={match.status} colorSchema={colorSchema} size={size}>
        <MatchCountdown matchDate={date} matchStatus={status} enabled={countdownEnabled}>
          {result.text}
        </MatchCountdown>
      </ResultLabel>
      <Team
        colorSchema={colorSchema}
        name={match.away.name}
        logoSize={logoSize}
        logoUrl={match.away.logoUrl}
        fontSize={fontSize}
        iconPosition="left"
        scoreboard={match.away.scoreboard}
        isLose={match.away.isLose}
        ampProps={ampProps}
      />
    </div>
  );
};

export default MatchLight;
